import { useDispatch, useSelector } from "react-redux";

import ReloadDataAfterSync from "scenes/Hubly/components/TopMenu/components/ContactSearch/actions";

import {
  ResetSyncProgress,
  TriggerAsyncJob,
  TriggerFullSync,
  TriggerMeetingsSync,
} from "./action";

export function useSync() {
  const dispatch = useDispatch();

  const { inProgress, percent, hub } = useSelector(({ hubly }) => {
    return hubly?.data?.hub?.selected;
  });

  return {
    syncInProgress: inProgress,
    syncProgress: percent,
    syncCompleted: !inProgress && percent === 100,
    resetSyncProgress: () => {
      dispatch(ResetSyncProgress());
    },
    runFullSync: () => {
      dispatch(TriggerFullSync());
    },
    runAsyncJob: (steps, onComplete) => {
      dispatch(TriggerAsyncJob(steps, onComplete));
    },
    runMeetingsSync: () => {
      dispatch(TriggerMeetingsSync());
    },
    reloadData: () => {
      dispatch(ReloadDataAfterSync(hub));
    },
  };
}

export default useSync;
